import React, { ReactElement } from 'react';
import styled from 'styled-components';
import Typography from 'shared/components/Typography';
import { defaultTheme } from 'shared/theme/theme';
import { Icon } from 'shared/theme/link-ui-react/Icon';

const ErrorIcon = styled(Icon).attrs({
  width: '24px',
  height: '24px',
})`
  fill: ${defaultTheme.colors.aux.red};
`;

const MessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const MessageText = styled(Typography)<{ error: boolean }>`
  color: ${p =>
    p.error ? defaultTheme.colors.aux.red : defaultTheme.colors.aux.darkGrey};
`;

const ActionsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const Message = ({
  children,
  title,
  error = false,
  actions,
}: {
  children: any;
  title?: string;
  error?: boolean;
  actions?: Array<ReactElement<any>>;
}) => (
  <MessageWrapper>
    {error && <ErrorIcon icon="Warning" />}
    <MessageText variant="subheading" title={title} error={error} gutterBottom>
      {children}
    </MessageText>
    <ActionsWrapper>
      {actions &&
        actions.map((action, index) =>
          React.cloneElement(action, { key: index })
        )}
    </ActionsWrapper>
  </MessageWrapper>
);

export default Message;
